module.exports = __webpack_public_path__ + "img/74.f69187fc.png";